module.exports = __webpack_public_path__ + "static/img/4.30a3c25.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/zh/4.png
// module id = MZOn
// module chunks = 0